import { getMentionTriggerIndex } from './mentionEmail';

export interface MentionCandidate {
  displayName: string;
  notifyEmail: string;
  mentionToken: string;
  audience: 'hub' | 'client' | 'internalContact';
}

export interface MentionCandidatesResponse {
  items: MentionCandidate[];
  reason?: string | null;
}

/** Text after `@` used to filter the server picker (before second `@`). */
export function getMentionPickerQuery(text: string): { triggerIndex: number; query: string } | null {
  const triggerIndex = getMentionTriggerIndex(text);
  if (triggerIndex === null) return null;
  const segment = text.slice(triggerIndex + 1);
  const secondAt = segment.indexOf('@');
  const query = secondAt >= 0 ? segment.slice(0, secondAt) : segment;
  return { triggerIndex, query };
}

/** Replace the open mention segment with a validated server token. */
export function applyMentionToken(text: string, triggerIndex: number, token: string): string {
  let end = text.length;
  const tail = text.slice(triggerIndex);
  const space = tail.search(/\s/);
  if (space >= 0) end = triggerIndex + space;
  const suffix = end < text.length ? text.slice(end) : ' ';
  return text.slice(0, triggerIndex) + token + (suffix.startsWith(' ') ? suffix : ` ${suffix}`);
}
